exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-container[data-v-38be1e65]{z-index:999;width:75%;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.slide-enter-active[data-v-38be1e65]{transition-duration:.1s;transition-timing-function:ease}.slide-enter-to[data-v-38be1e65],.slide-leave[data-v-38be1e65]{max-height:100px;overflow:hidden}.slide-enter[data-v-38be1e65],.slide-leave-to[data-v-38be1e65]{overflow:hidden;max-height:0}", ""]);

// exports
